import sortBy from "lodash/sortBy";

import useAllFields from "../../../hooks/useAllFields";
import useAuth from "../../../hooks/useAuth";
import useConfigurableFields from "../../../hooks/configurable-fields";

export default function useFilterFields() {
  const { user } = useAuth();
  const { settings } = user.company;
  const includeMedicalFields = settings?.medical_fields;
  const includeConfigurableCustomFields = settings?.user_configurable_custom_fields;

  const {
    identifiers,
    descriptiveInfo,
    warehouseInfo,
    originInfo,
    destinationInfo,
    electricalInfo,
    plumbingInfo,
    mechanicalInfo,
  } = useAllFields();
  const { configurableFields = [] } = useConfigurableFields();

  const sections = [
    identifiers,
    descriptiveInfo,
    warehouseInfo,
    originInfo,
    destinationInfo,
    ...(includeConfigurableCustomFields ? [configurableFields] : []),
    ...(includeMedicalFields ? [electricalInfo, plumbingInfo, mechanicalInfo] : []),
  ];

  const seen = new Set();
  const dynamicFields = [];

  sections.forEach(section => {
    section.forEach(([key, _category, label]) => {
      if (!seen.has(key)) {
        seen.add(key);
        dynamicFields.push([key, label]);
      }
    });
  });

  return sortBy(dynamicFields, v => (v[1] || "").toLowerCase());
}
